import { render, staticRenderFns } from "./prsForm.vue?vue&type=template&id=20103002&scoped=true"
import script from "./prsForm.vue?vue&type=script&lang=js"
export * from "./prsForm.vue?vue&type=script&lang=js"
import style0 from "./prsForm.vue?vue&type=style&index=0&id=20103002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20103002",
  null
  
)

export default component.exports